/**
 * ScrollToTopHandler — show/hide scroll-to-top button.
 * Migrated from dpss-theme.js lines 602-637.
 */

export class ScrollToTopHandler {
  private btn: HTMLElement | null;
  private readonly threshold = 100;

  constructor() {
    this.btn = document.querySelector(".scrollToTop");
    this.init();
  }

  private init(): void {
    if (!this.btn) return;

    this.btn.style.display = "block";
    this.btn.classList.add("js-fade-out");

    window.addEventListener("scroll", () => {
      if (window.scrollY > this.threshold) {
        this.btn!.classList.remove("js-fade-out");
        this.btn!.classList.add("js-fade-in");
      } else {
        this.btn!.classList.remove("js-fade-in");
        this.btn!.classList.add("js-fade-out");
      }
    });

    this.btn.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
}
